import React, { useEffect, useRef, useState, useCallback } from "react";

const features = [
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3 5.75A1.75 1.75 0 014.75 4h14.5A1.75 1.75 0 0121 5.75v9.5A1.75 1.75 0 0119.25 17H13l-2.5 3-2.5-3H4.75A1.75 1.75 0 013 15.25v-9.5z"
        />
      </svg>
    ),
    label: 'Pantalla Smart 86"',
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
      </svg>
    ),
    label: "Climatizacion frio/calor",
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 10h16M6 10V7.75A1.75 1.75 0 017.75 6h8.5A1.75 1.75 0 0118 7.75V10M7 10v7M17 10v7M7 14h10M10 14v3M14 14v3" />
      </svg>
    ),
    label: "Mobiliario incluido (mesas y sillas)",
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 19V9.75A1.75 1.75 0 016.75 8h10.5A1.75 1.75 0 0119 9.75V19M5 15h14M9 8V5.75A1.75 1.75 0 0110.75 4h2.5A1.75 1.75 0 0115 5.75V8M9 19v-4m6 4v-4" />
      </svg>
    ),
    label: "Pelotero 3 niveles c/obstaculos (el mas grande de la zona)",
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
      </svg>
    ),
    label: "Capacidad: 75 adultos + 40 ninos",
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16.5l4.5-4.5 3 3L20 6.5M14 6.5h6v6" />
      </svg>
    ),
    label: "Cancha de futbol techada",
  }
];

const GALLERY_PHOTOS = [
  {
    src: "/images/magickingdomfuera.jpeg",
    alt: "Vista general del salón Magic Kingdom Eventos por fuera",
    fallback: "/images/magickingdomfuera.jpeg",
  },
  {
    src: "/images/salon-01.jpeg",
    alt: "Vista general del salón Magic Kingdom Eventos decorado para fiesta",
    fallback: "/images/salon-01.jpeg",
  },
  {
    src: "/images/pelotero.jpeg",
    alt: "Sector infantil con pelotero y juegos del salón",
    fallback: "/images/pelotero.jpeg",
  },
  {
    src: "/images/salon-03.jpeg",
    alt: "Cancha de futbol interna con césped sintético y red de contención",
    fallback: "/images/salon-03.jpeg",
  },
  {
    src: "/images/salon-04.jpeg",
    alt: "Sector adultos con iluminación festiva",
    fallback: "/images/salon-04.jpeg",
  },
  {
    src: "/images/salon-05.jpeg",
    alt: "Vista general del salon mostrando la mesa de los Adultos y la mesa de los chicos",
    fallback: "/images/salon-05.jpeg",
  },
  {
    src: "/images/salon-06.jpeg",
    alt: "Vista general del salon",
    fallback: "/images/salon-06.jpeg",
  },
  {
    src: "/images/salon-07.jpeg",
    alt: "Mesa de los chicos",
    fallback: "/images/salon-07.jpeg",
  },
  {
    src: "/images/salon-08.jpeg",
    alt: "Pantalla de Magic Kingdom",
    fallback: "/images/salon-08.jpeg",
  },
  {
    src: "/images/salon-09.jpeg",
    alt: "Castillo del salon",
    fallback: "/images/salon-09.jpeg",
  },
  {
    src: "/images/cumpleadultos.jpeg",
    alt: "Mesa de Pool",
    fallback: "/images/cumpleadultos.jpeg",
  },
];

function ArrowBtn({
  direction,
  onClick,
  label,
  size = "md",
}: {
  direction: "left" | "right";
  onClick: (e: React.MouseEvent) => void;
  label: string;
  size?: "sm" | "md";
}) {
  const dim = size === "sm" ? "w-8 h-8" : "w-10 h-10";
  const icon = size === "sm" ? "w-3.5 h-3.5" : "w-4 h-4";
  return (
    <button
      className={`${dim} rounded-full bg-black/40 hover:bg-primary backdrop-blur-sm text-white flex items-center justify-center transition-all duration-200 hover:scale-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold`}
      onClick={onClick}
      aria-label={label}
    >
      <svg className={icon} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2.5}
          d={direction === "left" ? "M15 19l-7-7 7-7" : "M9 5l7 7-7 7"}
        />
      </svg>
    </button>
  );
}

// ── Lightbox (foto expandida) ─────────────────────────────────────────────────
function Lightbox({
  photos,
  index,
  onClose,
  onGoto,
}: {
  photos: typeof GALLERY_PHOTOS;
  index: number;
  onClose: () => void;
  onGoto: (i: number) => void;
}) {
  const total = photos.length;
  const prev = useCallback(() => onGoto((index - 1 + total) % total), [index, total, onGoto]);
  const next = useCallback(() => onGoto((index + 1) % total), [index, total, onGoto]);

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    };
    window.addEventListener("keydown", handleKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", handleKey);
      document.body.style.overflow = "";
    };
  }, [onClose, prev, next]);

  const photo = photos[index];

  return (
    <div
      className="fixed inset-0 z-[200] bg-black/95 backdrop-blur-md flex items-center justify-center p-4"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={`Foto ${index + 1} de ${total}: ${photo.alt}`}
    >
      {/* Close */}
      <button
        className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/10 hover:bg-white/25 text-white flex items-center justify-center transition-colors z-10"
        onClick={onClose}
        aria-label="Cerrar foto"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      {/* Counter */}
      <div className="absolute top-4 left-4 bg-black/40 backdrop-blur-sm rounded-full px-3 py-1.5 z-10">
        <span className="font-body text-white text-sm">{index + 1} / {total}</span>
      </div>

      {/* Prev arrow */}
      <div className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 z-10">
        <ArrowBtn direction="left" onClick={(e) => { e.stopPropagation(); prev(); }} label="Foto anterior" />
      </div>

      {/* Image */}
      <div
        className="max-w-5xl w-full flex flex-col items-center"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={photo.src}
          alt={photo.alt}
          onError={(e) => { (e.target as HTMLImageElement).src = photo.fallback; }}
          className="w-full object-contain rounded-2xl"
          style={{ maxHeight: "80vh" }}
        />
        <p className="text-white/45 text-xs text-center mt-3 font-body px-8">{photo.alt}</p>
      </div>

      {/* Next arrow */}
      <div className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 z-10">
        <ArrowBtn direction="right" onClick={(e) => { e.stopPropagation(); next(); }} label="Foto siguiente" />
      </div>

      {/* Dot strip */}
      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex gap-2 flex-wrap justify-center max-w-xs">
        {photos.map((_, i) => (
          <button
            key={i}
            onClick={(e) => { e.stopPropagation(); onGoto(i); }}
            className={`rounded-full transition-all duration-300 ${i === index ? "w-6 h-2 bg-gold" : "w-2 h-2 bg-white/30 hover:bg-white/60"
              }`}
            aria-label={`Ir a foto ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
}

// ── Modal galería completa ────────────────────────────────────────────────────
function GalleryModal({
  photos,
  onClose,
  onExpand,
}: {
  photos: typeof GALLERY_PHOTOS;
  onClose: () => void;
  onExpand: (i: number) => void;
}) {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", handleKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", handleKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[150] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Galería completa del salón"
    >
      <div
        className="bg-surface rounded-3xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-accent/20 shrink-0">
          <div>
            <h3 className="font-display text-primary text-xl font-bold">Galería del salón</h3>
            <p className="font-body text-text/50 text-sm">{photos.length} fotos · tocá para ampliar</p>
          </div>
          <button
            className="w-9 h-9 rounded-full bg-background hover:bg-accent/20 text-text flex items-center justify-center transition-colors"
            onClick={onClose}
            aria-label="Cerrar galería"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Grid de fotos */}
        <div className="overflow-y-auto p-4 flex-1">
          <ul
            className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3"
            role="list"
          >
            {photos.map((photo, i) => (
              <li key={i}>
                <button
                  className="relative w-full aspect-square rounded-xl overflow-hidden group focus:outline-none focus-visible:ring-4 focus-visible:ring-gold"
                  onClick={() => onExpand(i)}
                  aria-label={`Ver foto: ${photo.alt}`}
                >
                  <img
                    src={photo.src}
                    alt={photo.alt}
                    onError={(e) => { (e.target as HTMLImageElement).src = photo.fallback; }}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    loading="lazy"
                  />
                  {/* Hover overlay */}
                  <div className="absolute inset-0 bg-primary/40 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex items-center justify-center">
                    <div className="w-9 h-9 rounded-full bg-white/25 backdrop-blur-sm flex items-center justify-center">
                      <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                      </svg>
                    </div>
                  </div>
                  {/* Number badge */}
                  <div className="absolute top-2 left-2 w-6 h-6 rounded-full bg-black/40 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <span className="text-white text-xs font-bold">{i + 1}</span>
                  </div>
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

// ── GalleryThumb (desktop) ────────────────────────────────────────────────────
function GalleryThumb({
  photo,
  index,
  totalPhotos,
  onClick,
  onPrev,
  onNext,
  className = "",
  large = false,
  isLast = false,
  extraCount = 0,
  onOpenGallery,
}: {
  photo: (typeof GALLERY_PHOTOS)[0];
  index: number;
  totalPhotos: number;
  onClick: () => void;
  onPrev: (e: React.MouseEvent) => void;
  onNext: (e: React.MouseEvent) => void;
  className?: string;
  large?: boolean;
  isLast?: boolean;
  extraCount?: number;
  onOpenGallery?: () => void;
}) {
  return (
    <div className={`relative rounded-2xl overflow-hidden shadow-card group ${className}`}>
      <button
        className="w-full h-full focus:outline-none focus-visible:ring-4 focus-visible:ring-gold"
        onClick={onClick}
        aria-label={`Ver foto: ${photo.alt}`}
      >
        <img
          src={photo.src}
          alt={photo.alt}
          onError={(e) => { (e.target as HTMLImageElement).src = photo.fallback; }}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          loading="lazy"
        />
      </button>

      {/* "Ver galería" overlay en última thumb */}
      {isLast && (
        <button
          className="absolute inset-0 bg-primary/65 hover:bg-primary/75 flex flex-col items-center justify-center gap-2 transition-colors duration-300 focus:outline-none"
          onClick={onOpenGallery}
          aria-label="Abrir galería completa"
        >
          <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          <span className="font-body text-white font-semibold text-sm">Ver todas las fotos</span>
          {extraCount > 0 && (
            <span className="font-body text-white/70 text-xs">+{extraCount} más</span>
          )}
        </button>
      )}

      {/* Flechas ← → visibles en hover (solo cuando no es "ver galería") */}
      {!isLast && (
        <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 flex items-center justify-between px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none group-hover:pointer-events-auto">
          <ArrowBtn
            direction="left"
            size="sm"
            onClick={onPrev}
            label="Foto anterior"
          />
          <ArrowBtn
            direction="right"
            size="sm"
            onClick={onNext}
            label="Foto siguiente"
          />
        </div>
      )}

      {/* Badge "25 años" en foto grande */}
      {large && (
        <div className="absolute bottom-4 left-4 bg-surface/95 rounded-xl shadow-card px-4 py-2 flex items-center gap-2 border border-accent/20 pointer-events-none">
          <div className="w-9 h-9 rounded-full bg-gold-gradient flex items-center justify-center shadow-gold shrink-0">
            <span className="text-white font-display font-bold text-sm">25</span>
          </div>
          <div>
            <p className="font-display font-bold text-primary text-sm leading-tight">años</p>
            <p className="font-body text-secondary text-xs">de experiencia</p>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Mobile carousel ───────────────────────────────────────────────────────────
function MobileGallery({
  photos,
  onOpenGallery,
  onExpand,
}: {
  photos: typeof GALLERY_PHOTOS;
  onOpenGallery: () => void;
  onExpand: (i: number) => void;
}) {
  const [current, setCurrent] = useState(0);
  const prev = () => setCurrent((c) => (c - 1 + photos.length) % photos.length);
  const next = () => setCurrent((c) => (c + 1) % photos.length);
  const photo = photos[current];

  return (
    <div className="relative rounded-2xl overflow-hidden shadow-card aspect-[4/3]">
      {/* Image */}
      <button
        className="w-full h-full focus:outline-none"
        onClick={() => onExpand(current)}
        aria-label={`Ver foto: ${photo.alt}`}
      >
        <img
          src={photo.src}
          alt={photo.alt}
          onError={(e) => { (e.target as HTMLImageElement).src = photo.fallback; }}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </button>

      {/* Gradient bottom */}
      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/60 to-transparent pointer-events-none" />

      {/* Counter top-left */}
      <div className="absolute top-3 left-3 bg-black/40 backdrop-blur-sm rounded-full px-3 py-1 pointer-events-none">
        <span className="font-body text-white text-xs">{current + 1} / {photos.length}</span>
      </div>

      {/* Badge 25 años */}
      {current === 0 && (
        <div className="absolute top-3 right-3 bg-surface/95 rounded-xl shadow-card px-3 py-1.5 flex items-center gap-1.5 border border-accent/20 pointer-events-none">
          <div className="w-6 h-6 rounded-full bg-gold-gradient flex items-center justify-center shadow-gold shrink-0">
            <span className="text-white font-display font-bold text-xs">25</span>
          </div>
          <div>
            <p className="font-display font-bold text-primary text-xs leading-tight">años</p>
          </div>
        </div>
      )}

      {/* Arrows left/right */}
      <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 flex items-center justify-between px-3 pointer-events-none">
        <div className="pointer-events-auto">
          <ArrowBtn direction="left" size="sm" onClick={(e) => { e.stopPropagation(); prev(); }} label="Foto anterior" />
        </div>
        <div className="pointer-events-auto">
          <ArrowBtn direction="right" size="sm" onClick={(e) => { e.stopPropagation(); next(); }} label="Foto siguiente" />
        </div>
      </div>

      {/* Bottom bar: dots + ver galería */}
      <div className="absolute bottom-3 inset-x-3 flex items-center justify-between pointer-events-none">
        {/* Dots */}
        <div className="flex gap-1.5">
          {photos.map((_, i) => (
            <button
              key={i}
              onClick={(e) => { e.stopPropagation(); setCurrent(i); }}
              className={`rounded-full transition-all duration-300 pointer-events-auto ${i === current ? "w-5 h-1.5 bg-gold" : "w-1.5 h-1.5 bg-white/50"
                }`}
              aria-label={`Ir a foto ${i + 1}`}
            />
          ))}
        </div>

        {/* Ver galería */}
        <button
          className="flex items-center gap-1.5 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white font-body text-xs font-semibold px-3 py-1.5 rounded-full transition-colors pointer-events-auto"
          onClick={(e) => { e.stopPropagation(); onOpenGallery(); }}
          aria-label="Ver todas las fotos del salón"
        >
          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          Ver galería
        </button>
      </div>
    </div>
  );
}

// ── Main component ────────────────────────────────────────────────────────────
export default function About() {
  const sectionRef = useRef<HTMLDivElement>(null);

  // Índices de las thumbs del mosaico desktop (ciclan dentro de GALLERY_PHOTOS)
  const GRID_SLOTS = 5;
  const [thumbIndexes, setThumbIndexes] = useState<number[]>(
    Array.from({ length: GRID_SLOTS }, (_, i) => i % GALLERY_PHOTOS.length)
  );

  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);
  const [showGalleryModal, setShowGalleryModal] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target
              .querySelectorAll(".reveal, .reveal-left, .reveal-right")
              .forEach((el) => el.classList.add("visible"));
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  // Navegar la thumb en el slot `slot` hacia atrás/adelante
  const navigateThumb = (slot: number, dir: -1 | 1) => {
    setThumbIndexes((prev) => {
      const next = [...prev];
      next[slot] = (next[slot] + dir + GALLERY_PHOTOS.length) % GALLERY_PHOTOS.length;
      return next;
    });
  };

  const openLightbox = (i: number) => { setShowGalleryModal(false); setLightboxIndex(i); };
  const closeLightbox = () => setLightboxIndex(null);
  const gotoLightbox = useCallback((i: number) => setLightboxIndex(i), []);

  return (
    <section
      id="salon"
      ref={sectionRef}
      className="py-24 bg-background relative overflow-hidden"
      aria-labelledby="salon-title"
    >
      <div className="absolute top-0 right-0 w-96 h-96 bg-accent/10 rounded-full -translate-y-1/2 translate-x-1/2 blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-primary/5 rounded-full translate-y-1/2 -translate-x-1/2 blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Texto intro */}
        <div className="text-center max-w-3xl mx-auto mb-14 reveal">
          <p className="section-subtitle mb-3">Nuestro espacio</p>
          <h2 id="salon-title" className="section-title mb-5">
            El salón que hace{" "}
            <span className="text-secondary italic">especial</span> tu festejo
          </h2>
          <div className="space-y-3 font-body text-text/75 text-lg leading-relaxed">
            <p>
              En <strong className="text-primary">Magic Kingdom Eventos</strong> creemos que las
              risas, los abrazos son esos momentos que quedan para siempre.
            </p>
            <p>
              Cada festejo es único, y nos importa que se sienta así. Más que un evento, creamos
              espacios para compartir, emocionarse y disfrutar de verdad.{" "}
              <strong className="text-primary">Más de 25 años de experiencia</strong> nos avalan.
            </p>
          </div>
        </div>

        {/* ── MOBILE: carousel ─────────────────────────────────────────────── */}
        <div className="md:hidden reveal mb-10">
          <MobileGallery
            photos={GALLERY_PHOTOS}
            onOpenGallery={() => setShowGalleryModal(true)}
            onExpand={openLightbox}
          />
        </div>

        {/* ── DESKTOP: mosaico asimétrico ──────────────────────────────────── */}
        <div className="hidden md:block reveal mb-14">
          <div
            className="grid gap-3"
            style={{
              gridTemplateColumns: "repeat(4, 1fr)",
              gridTemplateRows: "260px 260px",
            }}
          >
            {/* Slot 0 — grande 2×2 */}
            <GalleryThumb
              photo={GALLERY_PHOTOS[thumbIndexes[0]]}
              index={thumbIndexes[0]}
              totalPhotos={GALLERY_PHOTOS.length}
              onClick={() => openLightbox(thumbIndexes[0])}
              onPrev={(e) => { e.stopPropagation(); navigateThumb(0, -1); }}
              onNext={(e) => { e.stopPropagation(); navigateThumb(0, 1); }}
              className="col-span-2 row-span-2"
              large
            />
            {/* Slots 1-3 */}
            {[1, 2, 3].map((slot) => (
              <GalleryThumb
                key={slot}
                photo={GALLERY_PHOTOS[thumbIndexes[slot]]}
                index={thumbIndexes[slot]}
                totalPhotos={GALLERY_PHOTOS.length}
                onClick={() => openLightbox(thumbIndexes[slot])}
                onPrev={(e) => { e.stopPropagation(); navigateThumb(slot, -1); }}
                onNext={(e) => { e.stopPropagation(); navigateThumb(slot, 1); }}
                className="col-span-1 row-span-1"
              />
            ))}
            {/* Slot 4 — "Ver todas" */}
            <GalleryThumb
              photo={GALLERY_PHOTOS[thumbIndexes[4]]}
              index={thumbIndexes[4]}
              totalPhotos={GALLERY_PHOTOS.length}
              onClick={() => openLightbox(thumbIndexes[4])}
              onPrev={(e) => { e.stopPropagation(); navigateThumb(4, -1); }}
              onNext={(e) => { e.stopPropagation(); navigateThumb(4, 1); }}
              className="col-span-1 row-span-1"
              isLast
              extraCount={Math.max(0, GALLERY_PHOTOS.length - GRID_SLOTS)}
              onOpenGallery={() => setShowGalleryModal(true)}
            />
          </div>
          <p className="text-center font-body text-text/35 text-xs mt-3 select-none">
            Usá ← → en cada foto para navegar · tocá para ampliar
          </p>
        </div>

        {/* Features grid */}
        <div className="reveal">
          <h3 className="font-display text-primary text-2xl font-bold text-center mb-6">
            ¿Qué incluye el salón?
          </h3>
          <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" role="list">
            {features.map((f, i) => (
              <li
                key={i}
                className="flex items-center gap-3 bg-surface rounded-xl p-4 border border-accent/20 hover:border-accent/50 hover:shadow-green transition-all duration-200"
              >
                <span className="text-primary shrink-0">{f.icon}</span>
                <span className="font-body text-text text-sm font-medium">{f.label}</span>
              </li>
            ))}
          </ul>
          <div className="mt-8 flex flex-col items-center justify-center text-center">
            <span className="font-body text-text/55 text-sm font-medium tracking-[0.24em] uppercase">
              Segui bajando
            </span>
            <div className="mt-3 flex flex-col items-center text-primary" aria-hidden="true">
              {[0, 1, 2].map((arrow) => (
                <svg
                  key={arrow}
                  className="w-6 h-6 -mt-1 animate-bounce"
                  style={{ animationDelay: `${arrow * 150}ms` }}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M7 10l5 5 5-5" />
                </svg>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Modal galería completa */}
      {showGalleryModal && (
        <GalleryModal
          photos={GALLERY_PHOTOS}
          onClose={() => setShowGalleryModal(false)}
          onExpand={openLightbox}
        />
      )}

      {/* Lightbox foto expandida */}
      {lightboxIndex !== null && (
        <Lightbox
          photos={GALLERY_PHOTOS}
          index={lightboxIndex}
          onClose={closeLightbox}
          onGoto={gotoLightbox}
        />
      )}
    </section>
  );
}
